import { Entity, LiveData } from '@toeverything/infra';

import type { AccountTemplateListStore } from '../store/list';
import type { AccountTemplateMeta } from '../type';

export class AccountTemplateList extends Entity {
  constructor(private readonly store: AccountTemplateListStore) {
    super();
  }

  /** false when signed out */
  available$ = this.store.available$;
  loading$ = this.store.isLoading$;

  templates$ = LiveData.from(
    this.store.watchTemplates(),
    [] as AccountTemplateMeta[]
  ).map(templates =>
    [...templates].sort((a, b) => a.name.localeCompare(b.name))
  );

  count$ = this.templates$.map(templates => templates.length);

  template$(id: string) {
    return this.templates$.map(templates => templates.find(t => t.id === id));
  }

  get(id: string) {
    return this.store.get(id);
  }
}
